export default {
  male: 'Nam',
  female: 'Nữ',
} as const;
